// ...existing code...
import React, { useMemo } from "react";

interface BadgeProps {
    value: string | number;
    bgColor?: string;
    color?: string;
    size?: number | string; // number treated as px
    className?: string;
}

const STYLE_ID = "badge-component-styles";
if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
.badge-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-sizing: border-box;
  user-select: none;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  vertical-align: middle;
  overflow: hidden;
}
`;
    document.head.appendChild(style);
}

const Badge: React.FC<BadgeProps> = ({
    value,
    bgColor = "#5464B0",
    color = "#ffffff",
    size = 20,
    className = "",
}) => {
    const sizeCss = useMemo(() => (typeof size === "number" ? `${size}px` : size), [size]);

    const style: React.CSSProperties & { [key: string]: any } = {
        width: sizeCss,
        height: sizeCss,
        backgroundColor: bgColor,
        color: color,
        fontSize: `calc(${sizeCss} * 0.55)`,
    };

    return (
        <span
            className={`badge-circle ${className}`.trim()}
            style={style}
            aria-label={`badge-${value}`}
        >
            {value}
        </span>
    );
};

export default Badge;
